export function getRestfulId(item: Office.MessageRead) {
  return Office.context.mailbox.convertToRestId(
    item.itemId,
    Office.MailboxEnums.RestVersion.v2_0
  );
}
